import React from "react";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../hooks/useReveal";
import { TRUST_PORTAL_URL, heroImage } from "../data/siteContent";

const Hero = () => {
  return (
    <section
      className="relative min-h-screen flex items-end overflow-hidden"
      data-testid="hero-section"
    >
      <div className="absolute inset-0 scale-110">
        <img
          alt="A proud American family together in a warm home setting"
          className="w-full h-full object-cover"
          src={heroImage}
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/75 to-ink/55" />
      <div className="absolute inset-0 bg-gradient-to-r from-ink/75 via-ink/25 to-ink/40" />

      {/* Static (non-spinning) crest sized to naturally fill the right side
          of the hero -- low opacity so the family photo reads through it. */}
      <img
        src="/shield-logo.png"
        alt=""
        aria-hidden="true"
        draggable="false"
        className="hidden lg:block absolute top-1/2 right-[4%] -translate-y-1/2 h-[78%] w-auto opacity-[0.16] pointer-events-none select-none"
      />

      <div className="relative z-10 max-w-7xl mx-auto w-full px-5 sm:px-8 pb-20 sm:pb-28 pt-40">
        <div className="max-w-4xl">
          <p className="text-gold text-xs sm:text-sm tracking-[0.32em] uppercase font-semibold mb-8 flex items-center gap-4">
            <span className="h-px w-12 bg-gold" />A living trust. A legacy your
            family deserves. Protection that starts today.
          </p>
          <h1
            className="font-display text-3xl sm:text-5xl lg:text-6xl text-cream leading-[1.08] tracking-tight"
            data-testid="hero-headline"
          >
            <span className="block">I Served So Your Family</span>
            <span className="block">Would Never Lose</span>
            <span className="block">
              Everything They <em className="text-gold not-italic font-medium italic">Built.</em>
            </span>
          </h1>
          <p className="mt-8 text-cream/80 text-base sm:text-lg leading-relaxed max-w-2xl">
            I am not here to sell you something. Allow me to protect you
            first. Because of my service, I can give you access to tools and
            protections that wealthy families have used for generations.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-6">
            <a
              href={TRUST_PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-get-started-btn"
              className="group inline-flex items-center justify-center gap-3 bg-gold text-ink font-bold tracking-[0.1em] uppercase text-sm px-9 py-4 rounded-full hover:bg-goldlight transition-colors duration-300 shadow-[0_0_45px_rgba(201,162,60,0.4)] w-fit"
            >
              Get Started
              <ArrowRight className="w-[17px] h-[17px] transition-transform duration-300 group-hover:translate-x-1.5" />
            </a>
            <p className="text-cream/60 text-sm tracking-wide font-medium">
              U.S. Combat Veteran and Founder, Iron Gate Consulting
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-7 left-1/2 -translate-x-1/2 z-10 hidden sm:block" aria-hidden="true">
        <div className="w-px h-14 bg-gradient-to-b from-gold/0 via-gold to-gold/0 animate-pulse" />
      </div>
    </section>
  );
};

export default Hero;
